<template>
    <section>
        <div v-if="$route.name === 'Join'">
            <JoinIntro></JoinIntro>
        </div>
        <div v-else-if="$route.name === 'JoinExistSocial'">
            <JoinExistSocial></JoinExistSocial>
        </div>
        <div v-else>
            <TopAppBar
                :leftBtnMode="leftBtnMode"
                :rightBtnMode="rightBtnMode"
                :title="title"
                :leftBtnMethod="leftBtnMethod"
                :rightBtnMethod="rightBtnMethod"
                :hideCategory="true"
            >
            </TopAppBar>
            <div class="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust">
                <div class="mdc-layout-grid">
                    <div class="mdc-layout-grid__inner">
                        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


</template>

<script>
/**
 * 회원가입 메인 컴포넌트(sign up main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import JoinIntro from '@/components/join/Intro.vue'
import JoinExistSocial from '@/components/join/ExistSocial.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
export default {
    name: 'join',
    components: {
        JoinIntro, JoinExistSocial, TopAppBar
    },

    mixins: [topAppBarMixin],


    data() {
        return {
            joinStep: 'INTRO1'
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.name === 'JoinComplete') {
                this.setTopAppBarTitleOnly('')
            }else {
                this.setTopAppBarBackOnly('')
            }
        }
    },

    mounted() {
       this.setTopAppBarBackOnly('')
    },

    methods: {
        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
    }


}
</script>
